import {CheckoutGuestsInformationFormProvider} from "../checkoutGuestsInformationFormProvider";
import CheckOutSteps from "./steps";
import {CheckoutStepsWithoutGuests} from "./checkoutStepsWithoutGuests";
import {isGustsInformationRequired} from "../checkoutUtils";

export class CheckoutStepsProvider {

    constructor() {

        this.selectors = {

        };

        this.desktopStepsNode = document.getElementById('desktop-steps');
        this.mobileStepsNode = document.getElementById('desktop-steps');

        // @todo: Remove mobile dependencies.
        // this.mobileStepsNode = document.getElementById('mobile-steps');
    }

    getDesktopStepsNode()
    {
        return this.desktopStepsNode;
    }

    /**
     * @todo: Make deprecated.
     * @return {HTMLElement}
     */
    getMobileStepsNode()
    {
        return this.desktopStepsNode;
        // return this.mobileStepsNode;
    }

    /**
     * @return {CheckoutStepsWithoutGuests|CheckOutSteps}
     */
    getDesktopSteps()
    {
        if(isGustsInformationRequired()) {
            return new CheckOutSteps({
                node: this.desktopStepsNode,
            });
        } else {
            return new CheckoutStepsWithoutGuests({
                node: this.desktopStepsNode,
            });
        }
    }

    /**
     * @return {CheckoutStepsWithoutGuests|CheckOutSteps}
     */
    getMobileSteps()
    {
        if(isGustsInformationRequired()) {
            return new CheckOutSteps({
                node: this.mobileStepsNode,
            });

        } else {
            return new CheckoutStepsWithoutGuests({
                node: this.mobileStepsNode,
            });
        }
    }
}